import { render } from "./WithFormSelectedData.vue?vue&type=template&id=ddc175b6"
import script from "./WithFormSelectedData.vue?vue&type=script&lang=js"
export * from "./WithFormSelectedData.vue?vue&type=script&lang=js"

import "./WithFormSelectedData.vue?vue&type=style&index=0&id=ddc175b6&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__